import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

// Temporary landing spot for the INCLUDE branch until the redesigned page is
// assembled. Replaced, not extended.
export const ConfirmDrawdownPlaceholder = () => {
    return (
        <Text className="text-3xl font-bold">
            <FormattedMessage
                id="_.confirm_drawdown.placeholder.title"
                defaultMessage="Confirm your withdrawal"
            />
        </Text>
    );
};
